/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Asset properties for filtering.
 */
export var AssetPropertiesForTimeRangeFiltering;
(function (AssetPropertiesForTimeRangeFiltering) {
    AssetPropertiesForTimeRangeFiltering["TIMESTAMP"] = "timestamp";
})(AssetPropertiesForTimeRangeFiltering || (AssetPropertiesForTimeRangeFiltering = {}));
